import { createFileRoute } from '@tanstack/react-router';
import StepRouter from './-layouts/step-router';

export const Route = createFileRoute(
  '/_authenticated-chromeless/common-application/$stepPath',
)({
  component: StepRouter,
});
